// react-markdown's class on a ```mermaid fence's <code>.
export const MERMAID_LANGUAGE_CLASS_NAME = 'language-mermaid'

export const QA_NAME_GRETA_AI_CHAT_MERMAID = 'gretaAIChatMermaid'
